/* eslint-disable max-lines-per-function */
import "./../insGridPage.scss";
import { AuxButton, AuxGridColumnType } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFetchTagsQuery } from "../../tags/tagsApi";
import { TagEntityType } from "../../tags/types";
import { useSetPMIMenuItem } from "../use-menu-items";
import { InsDeletePortfolioAction } from "./insDeletePortfolioAction";
import usePortfolioDimensions from "./usePortfolioDimensions";
import { EntityType } from "api/admin/src";
import { insPortfoliosStateId } from "common/constants";
import { exportName } from "common/constants/exportName";
import { InsGridWidget } from "components";
import { InsBulkPMISelectionMenu } from "components/frame/insBulkPMISelectionMenu";
import { addCustomFieldsAsCols } from "components/modal/portfolio-creation-edit/helper";
import { ModalName } from "components/modal/types";
import { prepareTagRows } from "components/tags/helpers";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getDefaultMappings, insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { Permissions } from "feature-flag";
import { usePermission } from "feature-flag/hooks/usePermission";
import usePageTitle from "hooks/use-page-title";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setSelectedRowsState } from "store/grids";
import { openModal } from "store/modal";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
import { getCurrentLocalTime } from "common/date-utils";
export const handleDeleteButtonClicked = (deletePortfolioPermission, dispatch) => {
    if (!deletePortfolioPermission) {
        return;
    }
    dispatch(setSelectedRowsState({
        id: insPortfoliosStateId,
        selectedRows: []
    }));
};
export const InsPortfolios = () => {
    usePageTitle(`${language.en.common.titles.portfolios} - ${language.en.common.titles.base}`);
    const dispatch = useDispatch();
    const settingsPMIsMode = useSelector((state) => state.mainGridSettings.setPMIsMode, isEqual);
    const { customFields, data, querystate, measures, dimensions, refresh } = usePortfolioDimensions();
    const { data: dataTags } = useFetchTagsQuery({ entityType: TagEntityType.PORTFOLIO });
    const createPortfolioPermission = usePermission([Permissions.CREATE_PORTFOLIO]), deletePortfolioPermission = usePermission([Permissions.UPDATE_DELETE_PORTFOLIO]);
    const cols = [
        {
            field: "checkboxCol",
            floatingFilter: false,
            headerCheckboxSelection: settingsPMIsMode,
            headerName: " ",
            type: AuxGridColumnType.AUX_CHECKBOX_COLUMN,
            width: 32
        },
        { field: "Id", hide: true, lockVisible: true },
        { field: "Name", initialSort: "asc", type: [CustomColumnType.InsDatapointLinkColumn] },
        { enableRowGroup: true, field: "Currency", type: CustomColumnType.InsTextSetColumn },
        { enableRowGroup: true, field: "Ticker", type: CustomColumnType.AUX_TEXT_COLUMN },
        { enableRowGroup: true, field: "PortfolioType", type: CustomColumnType.AUX_TEXT_COLUMN },
        { enableRowGroup: true, field: "PortfolioKind", type: [CustomColumnType.InsPortfolioKindColumn, CustomColumnType.AUX_TEXT_COLUMN] },
        {
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: (params) => params.data.tags?.map((tag) => tag.label),
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn, CustomColumnType.AUX_TEXT_COLUMN]
        }
    ];
    addCustomFieldsAsCols(customFields, cols);
    let { rows } = insDatapointGridWidgetAdapterData(data, cols);
    rows = prepareTagRows(rows, dataTags);
    const defaultMappings = getDefaultMappings([{ dimensions, id: "", measures }], cols);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGridWidget, { suppressExcelExport: false, exportExcelName: exportName.Portfolios, stateId: insPortfoliosStateId, widgetId: insPortfoliosStateId, applyColumnsAutosize: true, columnDefs: cols, rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: insPortfoliosStateId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}`)
                }));
            }), rowData: rows, selectionMode: "multiple", refreshAction: refresh, queryState: querystate, dataMenu: [[useSetPMIMenuItem(insPortfoliosStateId)]], context: { linksMapping: defaultMappings }, allowTags: true, tagsEntityType: TagEntityType.PORTFOLIO, additionalNodes: [
                React.createElement(Fragment, { key: "portfolios-additional-nodes" },
                    React.createElement(InsDeletePortfolioAction, { onDeleteButtonClicked: () => handleDeleteButtonClicked(deletePortfolioPermission, dispatch), isDisabled: !deletePortfolioPermission }),
                    React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, onClick: () => {
                            if (!createPortfolioPermission) {
                                return;
                            }
                            appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.CreatePortfolioOpenModal, properties: { LocalTimestamp: getCurrentLocalTime() } });
                            dispatch(openModal({
                                content: {
                                    id: "portfolio-creation",
                                    modalName: ModalName.PortfolioCreation,
                                    parameters: {
                                        mode: AddInvestorAccountsOrFundsMode.Default
                                    }
                                },
                                title: language.en.modal.portfolioCreation.title,
                                type: "action"
                            }));
                        }, label: language.en.modal.portfolioCreation.title, isDisabled: !createPortfolioPermission }))
            ], headerLeft: settingsPMIsMode ? React.createElement(InsBulkPMISelectionMenu, { stateId: insPortfoliosStateId, entityType: EntityType.Portfolio }) : React.createElement(React.Fragment, null) }));
};
